import { useCallback, useEffect, useRef, useState } from 'react';

import generalEndpoints from '../../../../api/services/generalEndpoints';

export const useFetchOrgaos = () => {
  const [loading, setLoading] = useState();
  const [orgaos, setOrgaos] = useState([]);
  const isMounted = useRef(true);

  const fetchAllOrgaos = useCallback(async () => {
    setLoading(true);
    if (orgaos.length === 0) {
      try {
        const response = await generalEndpoints.getOrgaos();
        if (response.status === 200) {
          if (isMounted.current) setOrgaos(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllOrgaos().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllOrgaos]);

  return {
    loading,
    orgaos,
  };
};